export default __webpack_public_path__ + "graphic-design.426ba2b0.jpeg";